import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { Covid19Closure } from 'OpsCenter/ops-support/covid-19/closure/covid-19-closure';
import { RESOURCES } from 'OpsCenter/app.constants';

@Injectable()
export class Covid19ClosureService {
  constructor(private http: HttpClient) {
  }

  public getAllCountries(): Observable<any> {
    return this.http.get(RESOURCES.COUNTRY);
  }

  public save(merchantClosure: Covid19Closure): Observable<any> {
    return this.http.post('oc-api/operations/covid19/merchants-closure', merchantClosure);
  }
}



// WEBPACK FOOTER //
// ./src/app/ops-support/covid-19/closure/covid-19-closure.service.ts